//this is used to disply the images and quick information of the trips/others
import './tripCard.css';
import Carousel from '../carousel/Carousel';
import ReviewStars from '../reviewStars/ReviewStars';
import { ReactComponent as Location } from '../../assets/icons/trvto_location.svg';
import Calender from '../../assets/icons/trvto_calendar.svg';
import Organiser from '../../assets/icons/trvto_organiser.svg';
import { ReactComponent as LoveBlack } from '../../assets/icons/trvto_wishlist.svg';
import { ReactComponent as LoveRed } from '../../assets/icons/trvto_favorite.svg';
import { useContext, useEffect, useState } from 'react';
import { UserAuthContext } from '../../context/UserAuthContext';
import { handleWishlistClick } from '../../utils/wishlistHandler';
import { fetchWishlistData } from './getUserWishlist/getUserWishlist';
import { UserLoginSecContext } from '../../context/UserLoginSecContext';
import { getHikedPrice } from '../../utils/getAmountWithTransaction';
import { useLocation } from 'react-router-dom';
import formatedTripData from './formatTripData/formatTripData';
import ListingCard from './listingCard/ListingCard';

// details page URL (v2 passes its own, which also uses the title)
const defaultDetailsPath = (type, id) => `/${type}/details/${id}`;

export default function TripCard({
    imageData,
    interested,
    type,
    handleDelete,
    myWishList,
    detailsPath = defaultDetailsPath
}) {
    const [userWishlist, setUserWishlist] = useState([]);
    const { setLogButton, setLoginSec } = useContext(UserLoginSecContext);
    const { isAuthenticated } = useContext(UserAuthContext);
    const USER_IDS = ['686f837afe8ded032c47991a', '6892ebe235b0fc3f961f5146', '689353907109f98a28d23771'];

    useEffect(() => {
        fetchWishlistData(type, setUserWishlist);
    }, [type, setLogButton]);

    const handleTripCardClick = (packId) => {
        const title = imageData?.find((item) => item._id === packId)?.title;
        return window.open(detailsPath(type, packId, title), '_blank', 'noopener,noreferrer');
    };

    const handleWishListClick = (id) => {
        if (isAuthenticated) {
            handleWishlistClick(id, userWishlist, type, setUserWishlist);
        } else {
            setLogButton(true);
            setLoginSec('login');
        }
    };

    return imageData?.map((dataItem) => {
        const formattedData = formatedTripData(dataItem, type);
        const isFavorite = Array.isArray(userWishlist) ? userWishlist.includes(dataItem._id) : false;
        return (
            <ListingCard
                key={formattedData?._id}
                type={type}
                {...formattedData}
                isFavorite={isFavorite}
                onTripCardClick={handleTripCardClick}
                onWishListClick={handleWishListClick}
                handleDelete={handleDelete}
                myWishList={myWishList}
                interested={interested}
            />

        );
    });
}
